<div id="small_guide_wrap">
    {{content}}
</div>



// WEBPACK FOOTER //
// ./src/app/small-guide/small-guide.component.html